import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';

export const API_DOMAIN: EndPointsNames = 'ApiLaunchdarkly';
export const ENDPOINT_API_PATH =
  'api/v2/users/:project/:environment/:user/flags/:flag';
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'NOT_CREDENTIALS';
const URL_POSTMAN = 'http://www.smiles.com.br';
export const CODE_ERRORS: ErrorResponseCodeType[] = [];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};
